  <section>
    <div id="loginBox">
      <h1>Passwort vergessen?</h1>
      <p>Kennen wir alle - wem ist das denn noch nicht passiert? Trag deinen Email unten ein und frag einen Link zum Neusetzen des Passwortes an.
      </p>
      <form #form="ngForm" (ngSubmit)="sendMail()">
        <input required name="email" id="email" placeholder="Emailadresse" [(ngModel)]="email" #emailInput="ngModel" />
        <button type="submit" [disabled]="!form.valid || this.sent">{{ this.buttonText }}</button>
      </form>
      @if (errorMessage) {<p  class="errorMessage">{{ errorMessage }}</p>}
      <p id="infoBox">
      </p>
    </div>
  </section>
